const COUPON_TYPE = {
	custom: 'CUSTOM',
	firstOrder: 'FIRST_ORDER',
};

export default COUPON_TYPE;